<div
  class="profile-card cursor mb-12"
  *ngFor="let contact of contacts"
  (click)="onContactClick(contact)"
  onKeyDown="onContactClick(contact)"
>
  <div class="profile-top">
    <div class="profile-photo-wrapper">
      <img
        *ngIf="getSafePhotoUrl(contact?.photo)"
        [src]="getSafePhotoUrl(contact?.photo)"
        alt="Profile"
        class="profile-photo"
      />
      <div *ngIf="!getSafePhotoUrl(contact?.photo)" class="profile-placeholder">
        {{ contact?.displayName | userInitials }}
      </div>
    </div>

    <div class="profile-info">
      <div class="name-row">
        <div class="profile-name">
          {{ contact?.displayName }}
        </div>
         <div class="profile-icons">
          <i
            class="pi pi-trash icon edit"
            *ngIf="!isEditing"
            (click)="deleteContact($event, contact)"
          ></i>
        </div>
      </div>

      <!-- VIEW MODE role/department -->
      <div class="profile-role-dept">
        <div class="profile-title">
          {{ contact?.jobTitle ?? "No title available" }}
        </div>
        <div class="profile-department" *ngIf="contact?.department">
          {{ contact?.department ?? "No department information" }}
        </div>
      </div>
    </div>
  </div>
</div>